import { reduce } from 'lodash'

type roundDate = {
  day: number
  month: number
}

export type AppRound = {
  id: string
  updatedBy: string
  updatedAt: string
  updatedByName: string
  updatedBySystem: string
  scid: number
  name: string
  customType?: string
  binding: boolean
  applicantType?: 'firstYear' | 'transfer' | undefined
  cutoff?: roundDate
  cutoffDate?: string
  deadline?: roundDate
  deadlineDate?: string
  materialsDeadlineDate?: string
  requirementsId?: string
}

export type RequirementValue = 'AsAvailable' | 'DoNotSend' | 'Required' | 'PendingRequired'
type RecommendationRequirement = {
  RequiredCount: number
  OptionalSendStatus: RequirementValue
}

export const academicRecordKeyMap = {
  InitialTranscript: 'InitialTranscript',
  TransferTranscript: 'TransferTranscript',
  AdditionalTranscript: 'AdditionalTranscript',
  SeniorCourses: 'SeniorCourses',
  MidYearTranscript: 'MidYearTranscript',
  MidYearReport: 'MidYearReport',
  FinalTranscript: 'FinalTranscript',
  FinalReport: 'FinalReport',
} as const
export type academicRecordKeys = (typeof academicRecordKeyMap)[keyof typeof academicRecordKeyMap]

export const docTypesWithPendingRequired: academicRecordKeys[] = [
  academicRecordKeyMap.MidYearTranscript,
  academicRecordKeyMap.MidYearReport,
  academicRecordKeyMap.FinalTranscript,
  academicRecordKeyMap.FinalReport,
]

export const supportingDocumentKeyMap = {
  SecondarySchoolReport: 'SecondarySchoolReport',
  SchoolProfile: 'SchoolProfile',
  FERPAWaiver: 'FERPAWaiver',
  FeeWaiver: 'FeeWaiver',
  ACTScoreReport: 'ACTScoreReport',
  SATScoreReport: 'SATScoreReport',
  OtherDocuments: 'OtherDocuments',
  GradeReport: 'GradeReport',
} as const
export type supportingDocumentKeys = (typeof supportingDocumentKeyMap)[keyof typeof supportingDocumentKeyMap]

export const transferRequirementKeyMap = {
  CollegeTranscript: 'CollegeTranscript',
  HighSchoolTranscript: 'HighSchoolTranscript',
  TransferReport: 'TransferReport',
  MidTermReport: 'MidTermReport',
} as const
export type transferRequirementKeys = (typeof transferRequirementKeyMap)[keyof typeof transferRequirementKeyMap]

export type academicRecordsMap = {
  [key in academicRecordKeys]?: RequirementValue
}
export type supportingDocumentsMap = {
  [key in supportingDocumentKeys]?: RequirementValue
}
export type transferRequirementsMap = {
  [key in transferRequirementKeys]?: RequirementValue
}

export const listOfAcademicRecordKeys = reduce(
  academicRecordKeyMap,
  (reducerValue: academicRecordKeys[], key: academicRecordKeys) => {
    reducerValue.push(key)
    return reducerValue
  },
  [],
)

export const listOfSupportingRecordKeys = reduce(
  supportingDocumentKeyMap,
  (reducerValue: supportingDocumentKeys[], key: supportingDocumentKeys) => {
    reducerValue.push(key)
    return reducerValue
  },
  [],
)

export const listOfTransferRequirements = reduce(
  transferRequirementKeyMap,
  (reducerValue: transferRequirementKeys[], key: transferRequirementKeys) => {
    reducerValue.push(key)
    return reducerValue
  },
  [],
)

export type RoundRequirement = {
  id: string
  name: string
  applicantType?: 'firstYear' | 'transfer' | undefined
  updatedBy: string
  updatedAt: string
  updatedByName: string
  recommendations: {
    min: number
    max: number
    teacher: RecommendationRequirement
    counselor: RecommendationRequirement
    other: RecommendationRequirement
  }
  academicRecords: academicRecordsMap
  supportingDocuments: supportingDocumentsMap
  transferRequirements: transferRequirementsMap
}
